import React from "react";

export class CacheStoreContextClass { 
    public storeByName: Map<string, Map<any, any>> = new Map<string, Map<any, any>>();
}

export const CacheStoreContext = React.createContext<CacheStoreContextClass>(new CacheStoreContextClass());
